import { Component, EventEmitter, OnChanges, Output, SimpleChanges, effect, viewChildren, input, ChangeDetectionStrategy } from '@angular/core';
import { V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { Observable } from 'rxjs';

@Component({
  selector: 'coin-c-input-overlay',
  templateUrl: './input-overlay.component.html',
  styleUrls: ['./input-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputOverlayComponent implements OnChanges {
  public editValue = '';
  public isOverlayVisible = false;

  readonly inputType = input<'text' | 'number'>('text');
  readonly value = input<string>(undefined);
  readonly isEditable = input(true);
  readonly infoHeader = input<string>(undefined);
  readonly infoText = input<string>(undefined);
  readonly placeholder = input<string>(undefined);
  readonly noValueText = input<string>(undefined);
  readonly choices = input<string[]>(undefined);
  readonly choicesWithSearch = input(false);
  readonly isSmall = input(false);
  readonly displayFn = input<(arg0: unknown) => string>(arg0 => (arg0 ? `${arg0}` : (arg0 as string)));
  readonly lazyLoadChoicesFn = input<(search: string) => Observable<unknown[]>>(undefined);

  @Output() valueChanged = new EventEmitter<string>();

  readonly inputComponents = viewChildren(V2TextInputComponent);

  constructor() {
    effect(() => {
      const firstInput = this.inputComponents().at(0);
      if (firstInput) {
        firstInput.focus();
        this.editValue = this.value();
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.editValue = changes.value?.currentValue;
  }

  public originClicked(): void {
    this.toggleOverlay();
  }

  public saveClicked(): void {
    this.valueChanged.emit(this.editValue);
    this.resetAndClose();
  }

  public cancelClicked(): void {
    this.resetAndClose();
  }

  private resetAndClose(): void {
    this.editValue = '';
    this.toggleOverlay();
  }

  public toggleOverlay(): void {
    this.isOverlayVisible = !this.isOverlayVisible;
  }
}
